import { render } from "./AppSpacer.vue?vue&type=template&id=8e8b2e74&bindings={\"height\":\"props\",\"styles\":\"options\"}"
import script from "./AppSpacer.vue?vue&type=script&lang=js"
export * from "./AppSpacer.vue?vue&type=script&lang=js"

import "./AppSpacer.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script